import type { CompassScorecard } from '../../types';

export const isCompassScorecard = (entity: any): entity is CompassScorecard =>
	entity.__typename === 'CompassScorecard';

export const getCompassScorecardLink = (scorecard: CompassScorecard): string | null =>
	scorecard?.scorecardUrl ?? null;
